import Model from "./Model";

export default class InstitutionModel extends Model {
  id: number;
  title: string;
  acronym: string;
  cityId: number;
  code: string;

  static __typename: string = "Institution";

  constructor(institution: any, getters: any) {
    super(getters);
    this.id = institution.id;
    this.title = institution.title;
    this.acronym = institution.acronym;
    this.cityId = institution.cityId;
    this.code = institution.code;
  }

  raw() {
    return {
      id: this.id,
      title: this.title,
      acronym: this.acronym,
      cityId: this.cityId,
      code: this.code,
      __typename: InstitutionModel.__typename
    }
  }
}